import { Card, Dialog, DialogContent, DialogTitle, Divider, Grid, makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import {
  BooleanInput,
  Button,
  FormDataConsumer,
  SelectInput,
  TextInput,
  useDataProvider,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { CustomDatetime } from "../../../Components/CustomDatetime";
import { SectionTitle } from "../../../Components/SectionTitle";
import { Separator } from "../../../Components/Separator";
import ReliabilityReportRemarkTimeline from "../ReliabilityReportRemarks";
import { Add, Update } from "@material-ui/icons";
import { ReliabilityReportRemarkCreateModel } from "../Models/ReliabilityReportRemarkCreateModel";
import { useAppDataProvider } from "../../../../src/dataprovider";
import { ReliabilityReportUpdateModel } from "../Models/ReliabilityReportModels";
import { ReliabilityPrematureFailureUpdateModel } from "../Models/ReliabilityPrematureFailureModel";
import { ReliabilityReportStatusChoices } from "../../../../src/Enums/ReliabilityReportStatus";
import { ReliabilityReportTypeChoices } from "../../../../src/Enums/ReliabilityReportType";
import { useAuth } from "@airborne/react-admin";
import {
  ReliabilityPrematureFailureChoices,
  ReliabilityPrematureFailureStatus,
} from "../../../../src/Enums/ReliabilityPrematureFailureStatus";
import {
  ReliabilityNotPrematureFailureReasonType,
  ReliabilityPrematureFailureReasonType,
  ReliabilityPrematureFailureRejectReasonType,
} from "../../../../src/Enums/ReliabilityPrematureFailureReasonType";
import ReliabilityOtherConditions from "../ReliabilityOtherConditions";

const useStyles = makeStyles(theme => ({
  toolbar: {
    display: "flex",
    justifyContent: "end",
  },
  gridItem: {
    margin: "0px 10px",
  },
}));

export const PrematureFailureDetail = props => {
  const provider = useDataProvider();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({} as any);
  const notify = useNotify();
  const [isReliabilityReportButtonShow, setIsReliabilityReportButtonShow] = useState(false);
  const [isPrematureFailureButtonShow, setIsPrematureFailureButtonShow] = useState(false);
  const [isDisabledReportFields, setIsDisabledReportFields] = useState(true);
  const [isDisabledPrematureFailureFields, setIsDisabledPrematureFailureFields] = useState(true);
  const [isReasonRequired, setIsReasonRequired] = useState(false);
  const [isPrematureFailure, setIsPrematureFailure] = useState(null as any);
  const dataProvider = useAppDataProvider();
  const { user } = useAuth();

  React.useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    provider
      .getOne("reliabilityprematurefailures", {
        id: props.id,
      })
      .then(response => {
        setData(response.data);

        if (
          response.data.prematureFailureStatus === ReliabilityPrematureFailureStatus.Rejected ||
          response.data.prematureFailureStatus === ReliabilityPrematureFailureStatus.NotPrematureFailure
        ) {
          response.data.prematureFailureStatus === ReliabilityPrematureFailureStatus.Rejected
            ? setIsPrematureFailure(false)
            : setIsPrematureFailure(true);
          setIsReasonRequired(true);
        } else {
          setIsReasonRequired(false);
        }
      })
      .catch(error => {});
  };
  const editReliabilityReport = e => {
    setIsReliabilityReportButtonShow(true);
    setIsDisabledReportFields(false);
  };

  const editReliabilityReportButtonClick = formValues => e => {
    let reliabilityReport: ReliabilityReportUpdateModel = new ReliabilityReportUpdateModel();
    reliabilityReport.Id = data?.report?.id;
    reliabilityReport.Pn = data?.report?.pn;
    reliabilityReport.Sn = data?.report?.sn;
    reliabilityReport.GoodsRcvdBatch = data?.report?.goodsRcvdBatch;
    reliabilityReport.Chapter = data?.report?.chapter;
    reliabilityReport.ReportStatus = formValues.reportStatus;
    reliabilityReport.ReportType = formValues.reportType;
    reliabilityReport.TargetDate = formValues.targetDate;

    dataProvider
      .putReliabilityReport(reliabilityReport)
      .then(result => {
        notify(`Reliability Report Updated`, "success", false, true);
        setIsReliabilityReportButtonShow(false);
        setIsDisabledReportFields(true);
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const CancelEditingReliabilityReport = e => {
    setIsReliabilityReportButtonShow(false);
    setIsDisabledReportFields(true);
  };

  const editPrematureFailure = e => {
    setIsPrematureFailureButtonShow(true);
    setIsDisabledPrematureFailureFields(false);
  };

  const editPrematureFailureButtonClick = e => {
    let reliabilityPrematureFailure: ReliabilityPrematureFailureUpdateModel =
      new ReliabilityPrematureFailureUpdateModel();
    reliabilityPrematureFailure.Id = data?.id;
    reliabilityPrematureFailure.RequestOrderId = data?.requestOrderId;
    reliabilityPrematureFailure.RequestType = data?.requestType;
    reliabilityPrematureFailure.ReportId = data?.report?.id;
    reliabilityPrematureFailure.BeforeRemovalOrderType = data?.beforeRemovalOrderType;
    reliabilityPrematureFailure.BeforeRemovalOrderNumber = data?.beforeRemovalOrderNumber;
    reliabilityPrematureFailure.BeforeRemovalOrderStatus = data?.beforeRemovalOrderStatus;
    reliabilityPrematureFailure.BeforeRemovalVendorType = data?.beforeRemovalVendorType;
    reliabilityPrematureFailure.BeforeRemovalVendor = data?.beforeRemovalVendor;
    reliabilityPrematureFailure.BeforeRemovalCondition = data?.beforeRemovalCondition;
    reliabilityPrematureFailure.AfterRemovalOrderType = data?.afterRemovalOrderType;
    reliabilityPrematureFailure.AfterRemovalOrderNumber = data?.afterRemovalOrderNumber;
    reliabilityPrematureFailure.AfterRemovalOrderStatus = data?.afterRemovalOrderStatus;
    reliabilityPrematureFailure.AfterRemovalVendorType = data?.afterRemovalVendorType;
    reliabilityPrematureFailure.AfterRemovalVendor = data?.afterRemovalVendor;
    reliabilityPrematureFailure.AfterRemovalCondition = data?.afterRemovalCondition;
    reliabilityPrematureFailure.PrematureFailureStatus = e.prematureFailureStatus;
    reliabilityPrematureFailure.Reason = e.reason;
    reliabilityPrematureFailure.OtherReason = e.otherReason;

    dataProvider
      .putReliabilityPrematureFailure(reliabilityPrematureFailure)
      .then(result => {
        notify(`Reliability Premature Failure Updated`, "success", false, true);
        setIsPrematureFailureButtonShow(false);
        setIsDisabledPrematureFailureFields(true);
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const CancelEditingPrematureFailure = e => {
    setIsPrematureFailureButtonShow(false);
    setIsDisabledPrematureFailureFields(true);
  };

  const AddReliabilityReportRemarkButton = props => {
    const [open, setOpen] = useState(false);

    const handleClick = e => {
      e.stopPropagation();
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };

    const AddReliabilityReportRemarkButtonClick = props => e => {
      let reliabilityRemark: ReliabilityReportRemarkCreateModel = new ReliabilityReportRemarkCreateModel();

      reliabilityRemark.ReliabilityReportId = props.reliabilityReportId;
      reliabilityRemark.IsVisibleToCustomer = e.isVisibleToCustomer;
      reliabilityRemark.Remark = e.remark;

      dataProvider
        .postReliabilityReportRemark(reliabilityRemark)
        .then(result => {
          notify(`Reliability Report Remark Added`, "success", false, true);
          history.go(0);
          setOpen(false);
        })
        .catch(result => notify(`${result}`, "error", false, true))
        .finally(() => setLoading(false));
    };

    const ClosePopup = () => {
      setOpen(false);
    };

    return (
      <>
        <Button label="Add Remark" disabled={loading} size="medium" variant="contained" onClick={handleClick}>
          {<Add />}
        </Button>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Reliability Report Remark</DialogTitle>
          <DialogContent>
            <Form
              onSubmit={AddReliabilityReportRemarkButtonClick(props)}
              render={({ handleSubmit }) => (
                <form>
                  <TextInput source="remark" label="remark" size="medium" fullWidth variant="outlined" />
                  <BooleanInput label="Is Visible To Customer" source="isVisibleToCustomer" defaultValue={false} />
                  <Button label={"Add Remark!"} size="large" variant="contained" onClick={handleSubmit}>
                    <Update />
                  </Button>
                  <Button label={"Cancel!"} size="large" variant="contained" onClick={ClosePopup} color="secondary">
                    <Update />
                  </Button>
                </form>
              )}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  };

  const CheckValidate = e => {
    if (
      e.target.value === ReliabilityPrematureFailureStatus.Rejected ||
      e.target.value === ReliabilityPrematureFailureStatus.NotPrematureFailure
    ) {
      e.target.value === ReliabilityPrematureFailureStatus.Rejected
        ? setIsPrematureFailure(false)
        : setIsPrematureFailure(true);
      setIsReasonRequired(true);
    } else {
      setIsReasonRequired(false);
    }
  };

  return (
    <>
      <Form
        onSubmit={() => {}}
        render={({ handleSubmit, form, values }) => {
          return (
            <form>
              <Card>
                <Grid container spacing={0} style={{ padding: 25 }}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <SectionTitle label="Reliability Report Details" />
                    <Divider style={{ padding: 0 }} />
                    <Separator />
                  </Grid>

                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <TextInput
                      source="goodsRcvdBatch"
                      label="Goods Received Batch"
                      initialValue={data?.report?.goodsRcvdBatch}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="chapter"
                      label="Chapter"
                      initialValue={data?.report?.chapter}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <SelectInput
                      source="reportStatus"
                      label="Report Status"
                      initialValue={data?.report?.reportStatus}
                      choices={ReliabilityReportStatusChoices}
                      optionText="key"
                      optionValue="value"
                      fullWidth
                      disabled={isDisabledReportFields}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <TextInput
                      source="pn"
                      label="PN"
                      initialValue={data?.report?.pn}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="pnDescription"
                      initialValue={data?.pnDescription}
                      label="PN Description"
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <CustomDatetime
                      source="targetDate"
                      label="Target Date"
                      initialValue={data?.report?.targetDate}
                      fullWidth
                      showTime
                      disabled={isDisabledReportFields}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <TextInput
                      source="sn"
                      label="SN"
                      initialValue={data?.report?.sn}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="pnSubCategory"
                      label="SUB Category"
                      initialValue={data?.pnSubCategory}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <SelectInput
                      source="reportType"
                      label="Report Type"
                      initialValue={data?.report?.reportType}
                      choices={ReliabilityReportTypeChoices}
                      optionText="key"
                      optionValue="value"
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={0} style={{ padding: 25, justifyContent: "start", margin: 10 }}>
                  <SectionTitle label="Reliability Other Condition" />
                  {data?.report?.goodsRcvdBatch != undefined && (
                    <ReliabilityOtherConditions goodsRcvdBatch={data?.report?.goodsRcvdBatch} />
                  )}
                </Grid>
                <Grid container spacing={0} style={{ padding: 25, justifyContent: "end" }}>
                  {!user?.isCustomer && !isReliabilityReportButtonShow && (
                    <Button
                      label="Edit Reliability Report"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={editReliabilityReport}
                      style={{ margin: "8px", background: "#ffc107" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                  {isReliabilityReportButtonShow && (
                    <Button
                      label="Edit"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={editReliabilityReportButtonClick(values)}
                      style={{ margin: "8px", background: "#4caf50" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                  {isReliabilityReportButtonShow && (
                    <Button
                      label="Cancel"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={CancelEditingReliabilityReport}
                      style={{ margin: "8px", background: "#ffc107" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                </Grid>
                <ReliabilityReportRemarkTimeline
                  reliabilityReportRemark={data?.reliabilityReportRemark}
                  refresh={getData}
                  isCustomerRelated={true}
                />
                <Grid container spacing={0} style={{ padding: 25, justifyContent: "end" }}>
                  {!user?.isCustomer && <AddReliabilityReportRemarkButton reliabilityReportId={data?.report?.id} />}
                </Grid>
              </Card>
            </form>
          );
        }}
      ></Form>

      <Separator />

      <Form
        initialValues={data}
        onSubmit={editPrematureFailureButtonClick}
        render={({ handleSubmit, form, values }) => {
          return (
            <form>
              <Card>
                <Grid container spacing={0} style={{ padding: 25 }}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <SectionTitle label="Premature Failure Details" />
                    <Divider style={{ padding: 0 }} />
                    <Separator />
                  </Grid>
                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <TextInput
                      source="refNo"
                      label="Ref No"
                      initialValue={data?.refNo}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="ownerCode"
                      label="Customer"
                      initialValue={data?.ownerCode}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="melCategory"
                      label="Category"
                      initialValue={data?.melCategory}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    {!user?.isCustomer && (
                      <>
                        <TextInput
                          source="beforeRemovalOrderType"
                          label="Before Removal Order Type"
                          initialValue={data?.beforeRemovalOrderType}
                          fullWidth
                          disabled
                          variant="outlined"
                        />
                        <TextInput
                          source="beforeRemovalOrderNumber"
                          label="Before Removal Order Number"
                          initialValue={data?.beforeRemovalOrderNumber}
                          fullWidth
                          disabled
                          variant="outlined"
                        />
                        <TextInput
                          source="beforeRemovalVendorType"
                          label="Before Removal Vendor Type"
                          initialValue={data?.beforeRemovalVendorType}
                          fullWidth
                          disabled
                          variant="outlined"
                        />
                        <TextInput
                          source="beforeRemovalVendor"
                          label="Before Removal Vendor"
                          initialValue={data?.beforeRemovalVendor}
                          fullWidth
                          disabled
                          variant="outlined"
                        />
                        <TextInput
                          source="beforeRemovalCondition"
                          label="Before Removal Condition"
                          initialValue={data?.beforeRemovalCondition}
                          fullWidth
                          disabled
                          variant="outlined"
                        />
                      </>
                    )}
                  </Grid>
                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <TextInput source="ac" label="AC" initialValue={data?.ac} fullWidth disabled variant="outlined" />
                    <CustomDatetime
                      source="requestCreatedDate"
                      label="Request Date"
                      initialValue={data?.requestDate}
                      fullWidth
                      showTime
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="requirementCategoryText"
                      label="Requirement Category"
                      initialValue={data?.requirementCategoryText}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="afterRemovalOrderType"
                      label="After Removal Order Type"
                      initialValue={data?.afterRemovalOrderType}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="afterRemovalOrderNumber"
                      label="After Removal Order Number"
                      initialValue={data?.afterRemovalOrderNumber}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="afterRemovalVendorType"
                      label="After Removal  Vendor Type"
                      initialValue={data?.afterRemovalVendorType}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="afterRemovalVendor"
                      label="After Removal Vendor"
                      initialValue={data?.afterRemovalVendor}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="afterRemovalCondition"
                      label="After Removal Condition"
                      initialValue={data?.afterRemovalCondition}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <SelectInput
                      source="prematureFailureStatus"
                      label="Premature Failure Status"
                      initialValue={data?.prematureFailureStatus}
                      choices={ReliabilityPrematureFailureChoices}
                      optionText="key"
                      optionValue="value"
                      fullWidth
                      onChange={CheckValidate}
                      disabled={isDisabledPrematureFailureFields}
                      variant="outlined"
                    />

                    {isReasonRequired && (
                      <SelectInput
                        source="reason"
                        label="Reject Reason"
                        initialValue={data?.reason}
                        choices={
                          isPrematureFailure
                            ? ReliabilityNotPrematureFailureReasonType
                            : ReliabilityPrematureFailureRejectReasonType
                        }
                        optionText="key"
                        optionValue="value"
                        fullWidth
                        disabled={isDisabledPrematureFailureFields}
                        variant="outlined"
                      />
                    )}

                    <FormDataConsumer>
                      {({ formData, ...rest }) =>
                        formData.reason === ReliabilityPrematureFailureReasonType.Other &&
                        isReasonRequired && (
                          <TextInput
                            source="otherReason"
                            label="Other Reason"
                            initialValue={data?.otherReason}
                            fullWidth
                            variant="outlined"
                            disabled={isDisabledPrematureFailureFields}
                            multiline
                            {...rest}
                          />
                        )
                      }
                    </FormDataConsumer>
                  </Grid>
                </Grid>
                <Grid container spacing={0} style={{ padding: 25, justifyContent: "end" }}>
                  {!user?.isCustomer && !isPrematureFailureButtonShow && (
                    <Button
                      label="Edit Premature Failure"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={editPrematureFailure}
                      style={{ margin: "8px", background: "#ffc107" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                  {isPrematureFailureButtonShow && (
                    <Button
                      label="Edit"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={handleSubmit}
                      style={{ margin: "8px", background: "#4caf50" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                  {isPrematureFailureButtonShow && (
                    <Button
                      label="Cancel"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={CancelEditingPrematureFailure}
                      style={{ margin: "8px", background: "#ffc107" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                </Grid>
              </Card>
            </form>
          );
        }}
      ></Form>
    </>
  );
};
export default PrematureFailureDetail;
